import {Component, inject, input, OnInit, output, signal} from '@angular/core';
import {SubsidyDossier} from '../../services/subsidy-dossiers/subsidy-dossier.model';
import {Router} from '@angular/router';
import {ReportBaseComponent} from '../../base/report-base.component';
import {getSubsidyConfig, SubsidyConfig} from '../../subsidies.config';

@Component({
	selector: 'tvsub-report-container',
	templateUrl: './report-container.component.html',
	styleUrls: ['./report-container.component.scss'],
	standalone: false
})
export class ReportContainerComponent implements OnInit {
	dossier = input.required<SubsidyDossier>();
	doSubmit = output<boolean>();

	parent = inject(ReportBaseComponent);
	config = signal<SubsidyConfig | null>(null);
	showCloseModal = signal(false);
	showSubmitModal = signal(false);

	#router = inject(Router);

	ngOnInit() {
		const config = getSubsidyConfig(this.dossier().type);
		this.config.set(config);
	}

	close(close: boolean) {
		if (close) {
			this.#router.navigate(['/']);
		}
	}

	trySubmit() {
		if (this.parent.isFormValid()) {
			this.showSubmitModal.set(true);
		}
	}

	submit(close: boolean) {
		this.doSubmit.emit(close);
	}
}
